const STARTLINE_MAX_LEND_UNDER_21 = 12500;
const STARTLINE_MAX_LEND_NOT_EMPLOYED = 10000;

module.exports = {
    STARTLINE_MAX_LEND_UNDER_21,
    STARTLINE_MAX_LEND_NOT_EMPLOYED
};